import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Button from '@components/dataEntry/button/Button';
import { CollectionPath } from '@typings/collections.enum';
import { useMasterPermission } from '@hooks/usePermission';

const ButtonWrap = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

type Props = {};
function StoreControlSec({ }: Props) {
  const navigate = useNavigate();
  const masterPermission = useMasterPermission({});

  if (!masterPermission) return null;
  return (
    <ButtonWrap>
      <Button
        shape="stroke"
        onClick={() => navigate(`/${CollectionPath.STORE}-npc`)}
      >
        npc 관리
      </Button>
      <Button
        shape="stroke"
        onClick={() => navigate(`/${CollectionPath.STORE}-luckydraw`)}
      >
        아이템 뽑기 관리
      </Button>
      <Button onClick={() => navigate(`/${CollectionPath.STORE}-history`)}>
        구매 히스토리
      </Button>
      <Button
        icon="Wheel18"
        onClick={() => navigate(`/${CollectionPath.STORE}-edit`)}
      >
        아이템 관리
      </Button>
    </ButtonWrap>
  );
}

export default StoreControlSec;